import { render, staticRenderFns } from "./HelpdeskQueryDrawer.vue?vue&type=template&id=08876bd0"
import script from "./HelpdeskQueryDrawer.vue?vue&type=script&lang=js"
export * from "./HelpdeskQueryDrawer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports